/*
  The browser's single door to the API.

  Everything sensitive now lives behind this boundary. The bundle carries a base
  URL and nothing else — no SMTP credentials, no service keys, no OTP logic. The
  server decides what is valid, what is rate limited and whether a code matches;
  this file only reports what it was told.
*/

/* REACT_APP_ variables are compiled into the public bundle, so this must never
   be anything but a public URL. Empty base = same origin, which is what a
   CloudFront behaviour routing /api to Cloud Run gives you. */
const BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");

/* Shown when the server sent nothing usable — a network drop, a proxy error
   page, a CORS rejection. Never the underlying exception. */
const FALLBACK_MESSAGE = "Something went wrong. Please try again.";
const OFFLINE_MESSAGE = "We couldn't reach the server. Check your connection and try again.";

export class ApiError extends Error {
  constructor(message, { status = 0, fieldErrors, retryAfterSeconds } = {}) {
    super(message || FALLBACK_MESSAGE);
    this.name = "ApiError";
    this.status = status;
    this.fieldErrors = fieldErrors;
    this.retryAfterSeconds = retryAfterSeconds;
    /* 429 and 5xx are worth retrying; a 400 is not. */
    this.isRateLimited = status === 429;
  }
}

async function postJson(path, payload, { signal } = {}) {
  let response;
  try {
    response = await fetch(`${BASE_URL}${path}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      signal,
    });
  } catch (err) {
    if (err?.name === "AbortError") throw err;
    throw new ApiError(OFFLINE_MESSAGE);
  }

  let body = null;
  try {
    body = await response.json();
  } catch {
    /* A gateway or proxy error can arrive as HTML. Fall through to the
       status-based message rather than surfacing a parse failure. */
  }

  if (!response.ok) {
    throw new ApiError(body?.message, {
      status: response.status,
      fieldErrors: body?.fieldErrors,
      retryAfterSeconds:
        body?.retryAfterSeconds ?? Number(response.headers.get("Retry-After")) ?? undefined,
    });
  }

  return body ?? {};
}

/** The enquiry form. Resolves once the server has accepted and sent the enquiry. */
export const submitDemoRequest = (payload, options) =>
  postJson("/api/demo-request", payload, options);
